/** Which size/density AgentBand renders at: FULL for the list card (44px min-height, shows
 *  the detail line), COMPACT for the board card (40px min-height, no detail line, no
 *  action label while WORKING). */
export enum AgentBandVariant {
  FULL = 'FULL',
  COMPACT = 'COMPACT',
}
